import type { i18n as I18n } from 'i18next';
import * as z from 'zod';
import { type TranslationKeys } from '../types/locale';
import { unCapitalizeFirstLetter } from '../utils/string.utils';

export const translateLocaleSentence = (
	keyConcat: string,
	getLocale: (key: TranslationKeys) => string
): string => {
	const keys = keyConcat.split(':') as TranslationKeys[];
	let sentence = '';

	for (let i = 0; i < keys.length; i++) {
		const key = keys[i];
		if (key) {
			const translated = getLocale(key);
			if (translated) {
				sentence +=
					i === 0 ? translated : unCapitalizeFirstLetter(translated);
			} else {
				console.warn(`Translation for key "${key}" not found.`);
			}
			if (i < keys.length - 1) {
				sentence += ' ';
			}
		}
	}

	return sentence;
};

export function flattenZodError(
	zodIssue: z.core.$ZodIssue[],
	i18n: I18n
): Record<string, string[]> {
	const result: Record<string, string[]> = {};

	for (const issue of zodIssue) {
		const path = issue.path.join('.') || '_root';

		// Prefer custom messages (if they exist in your locale)

		const isKey = issue.message.split(':').every((key) => i18n.exists(key));

		// Construct fallback i18n key based on issue.code
		const fallbackKey: TranslationKeys =
			`zodErrors.${issue.code}${issue.input ? `_${issue.input}` : ''}` as TranslationKeys;

		const isFallbackKey = i18n.exists(fallbackKey);

		const translationKey = isKey
			? issue.message
			: isFallbackKey
				? fallbackKey
				: issue.message;

		if (!result[path]) result[path] = [];
		result[path].push(translationKey);
	}

	return result;
}
